import { useTranslations } from 'next-intl';
import { useContentModule } from '@silvertours/front-entities';
import deutschlandTestSeal from './assets/deutschland-test-seal.svg';
import {
  DeutschlandTestSeal,
  Seals,
  TrustpilotCard,
} from './HomeTrustSeals.styles';
import type { SealsOrientation } from './HomeTrustSeals.styles';

type HomeTrustSealsProps = {
  /** `column` stacks the seals, `row` shows them side by side. */
  orientation: SealsOrientation;
};

/**
 * The trust seals of the index page variant: the Deutschland Test seal and
 * the Trustpilot rating from the page content. Without Trustpilot data, only
 * the Deutschland Test seal shows.
 */
const HomeTrustSeals = ({ orientation }: HomeTrustSealsProps) => {
  const t = useTranslations('features.stage');
  const { getTrustpilotData } = useContentModule();
  const trustpilot = getTrustpilotData();

  return (
    <Seals orientation={orientation} data-testid="home-trust-seals">
      <DeutschlandTestSeal
        src={deutschlandTestSeal}
        alt={t('homeFirstViewport.deutschlandTestSealAlt')}
        loading="eager"
        unoptimized
        $orientation={orientation}
      />
      {trustpilot && (
        <TrustpilotCard {...trustpilot} layout="stacked" showLabel={false} />
      )}
    </Seals>
  );
};

export { HomeTrustSeals };
export type { HomeTrustSealsProps };
